import React from 'react';
import { ThemeProvider } from 'styled-components';
import useDeviceWidth from '../../../hooks/getDeviceWidth';

const size = {
  mobileS: '320px',
  mobileM: '375px',
  mobileL: '425px',
  tablet: '768px',
  laptop: '1024px',
  laptopL: '1440px',
  desktop: '2560px'
};

export const device = {
  mobileS: `(max-width: ${size.mobileS})`,
  mobileM: `(max-width: ${size.mobileM})`,
  mobileL: `(max-width: ${size.mobileL})`,
  tablet: `(max-width: ${size.tablet})`,
  laptop: `(max-width: ${size.laptop})`,
  laptopL: `(max-width: ${size.laptopL})`,
  desktop: `(max-width: ${size.desktop})`,
  desktopL: `(max-width: ${size.desktop})`
};
interface P {
  children: React.ReactNode;
}
const usSendMoneyTheme = {
  feeDetailsWidth: '190px',
  media: {
    'common-dropdown-wrapper': `@media ${device.mobileL}{
            margin-left:-6px;
        }`,
    h1: `@media ${device.mobileL} { 
            font-size: 18px;
        }
        @media ${device.mobileS} { 
            font-size: 16px;
        }
        `,
    name: `@media ${device.mobileL} { 
            font-size: 20px;
            }
            @media ${device.mobileS} { 
                font-size: 18px;
            }
            `,
    accNo: `@media ${device.mobileL} { 
            font-size: 16px;
            
            }
            @media ${device.mobileS} { 
                font-size: 16px;
            }
            `,
    bankNo: `@media ${device.mobileL} { 
            font-size: 14px;
            }
            @media ${device.mobileS} { 
                font-size: 14px;
            }
            `,
    container: `@media ${device.mobileL} { 
            position:relative;
            grid-template-areas: 
            "logo info info"
            "logo info info"
            "logoIcon info info";
            }
            @media ${device.mobileS} { 
                font-size: 14px;
            }
            `,
    icon: `@media ${device.mobileL} { 
            position: absolute;
            bottom: 45%;
            }`,
    youSendTitle: `
        @media ${device.mobileL} { 
            font-size: 16px;
            }`,
    text: `
        @media ${device.mobileL} { 
            font-size: 24px;
            }`,
    flag: `
            @media ${device.mobileL}{
                height: 19px;
                width: 19px;
                margin-right: 6px;

            }
        `,
    link: `
        @media ${device.mobileL}{
            font-size: 16px;
        }
    `,

    currencyConverterContainer: `
    @media ${device.mobileL}{
        padding-left: 14px; 
    }
    `
  },
  fontSize: {
    baseFont: '10px',
    smm: '11px',
    lg: '30xp',
    sm: '18px',
    xsm: '12px',
    md: '20px',
    mdLg: '28px',
    nm: '16px',
    xm: '14px'
  },
  color: {
    buttonColor: '#091fa0',
    greyText: '#747474',
    blueText: '#091fa0',
    white: '#ffff',
    grey: '#fafafa',
    lightBlue: 'rgba(186, 243, 255, 0.2)',
    lightBlack: '#333333',
    blackText: '#1a1a1a',
    black: '#000000',
    blackGreyText: '747474',
    errorRed: '#d01313',
    blueLink: 'rgba(0, 193, 255, 1)',
    pinkLink: '#FE0095'
  },
  boxShadow: {
    buttonShadow: ' 0 0 5px 0 rgba(0, 193, 255, 0.7)',
    feeDropdownShadowActive: `0 2px 5px 0 rgba(0, 0, 0, 0.1)`,
    feeDropdownShadow: '0 0 2px 0 rgba(0, 0, 0, 0.07)',
    transactionDetailsShadow: '9px 8px 0 0 rgba(162, 157, 157, 0.1)'
  },
  border: {
    errorBorder: 'solid 1px #d01313',
    feeDropdownBorderActive: '',
    transactionDetailsBorder: 'solid 1px #c6f4fe'
  },
  padding: {
    leftRight: '0 10px',
    bottom: '20px',
    left: '20px',
    longPadding: '10px 60px'
  },
  borderRadius: {
    lg: '4px',
    sm: '4px'
  },
  fontWeight: 500,
  width: {
    sm: '35%'
  }
};

export const ThemeProviderContainer: React.FC<P> = ({ children }: P) => {
  const { width = 1200 } = useDeviceWidth();
  const smallFontSize = {
    baseFont: '10px',
    smm: '11px',
    lg: '30xp',
    sm: '18px',
    xsm: '12px',
    md: '20px',
    mdLg: '18px', // 28px
    nm: '16px',
    xm: '14px'
  };
  let theme = usSendMoneyTheme;
  if (width && width < 600) {
    theme = { ...usSendMoneyTheme, fontSize: smallFontSize };
  }
  return <ThemeProvider theme={theme}>{children}</ThemeProvider>;
};
